<template>
<div>
      <!-- class="flex" -->
  <xui-select
      disable-filter
      has-search
      :label="label || ''"
      :placeholder="placeholder || 'Select...'"
      search-placeholder="Type to search..."
      :options="items"
      :keys="{id: optionKey, label:  optionLabel}"
      v-model="selectedItem"
      @input="updateValue"
      :type="type || 'basic'"
      :loading="select11Loading"
      :no-results="select11NoResults"
      @query-change="onQueryChange"

  >
    <!-- <div slot="no-results">
        <p>Searched {{ label }} not found! <v-chip v-if="hasAddNew" color="blue" small class="pointer"  @click="$emit('createNew', true)"><span class="english"> ADD NEW </span></v-chip></p>
    </div> -->

  </xui-select>
  <div v-for="error in myErrors" :key="error">
    {{error}}
  </div>
</div>
</template>

<script>
import axios from '@/plugins/axios'
import UiSelect from './UiSelect.vue'
import {debounce} from 'lodash'

export default {
  name: 'NewSelect',
  extends: {

  },
  data () {
    return {
      items: [],
      selectedItem: {},
      myErrors: [],
      myLabel: '',
      select11Loading: false,
      select11NoResults: false,
      select11LoadingTimeout: null,
      fetchedCurrentItem : false


    }
  },

  components: {
    'xui-select': UiSelect
  },

  props: [
    'label',
    'value',
    'url',
    'placeholder',
    'optionLabel',
    'optionKey',
    'options',
    'type',
    'remoteSearch',
    'mode',
    'initUrl',
    'hasAddNew',
    'trimDisabled',
    'search',
  ],



  computed: {
  },

  methods: {
    loadOptions() {
      axios.get(this.url).then((resp) => {
        this.items = resp.data
      })
    },

    loadCurrentValue() {
        if(this.initUrl && this.value) {
            let searchUrl = this.initUrl + '/' + this.value
            return axios.get(searchUrl).then((resp) => {
                    this.fetchedCurrentItem = true;

                this.items.push(resp.data)
                return resp

            })
        }
        return Promise.reject('notloaded');


    },

    updateValue(value) {

      if(this.mode === 'object') {
        this.$emit('input', value)
      } else {
        this.$emit('input', value[this.optionKey])
      }

    },

    updateValueFromParent(newValue) {
        // console.log('updaing from parent')
      if(this.mode === 'object') {
        this.selectedItem = this.value
      } else {
        let itemObject = this.items.find(item => item[this.optionKey] === newValue) || null
        this.selectedItem = itemObject || {}
        if(!itemObject && this.initUrl) {
            this.loadCurrentValue().then( () => {
                let itemObject = this.items.find(item => item[this.optionKey] === newValue) || null
                this.selectedItem = itemObject || {}



            }).catch( (error) => error)
        }


        // console.log('selected', itemObject)

      }




    },

    updateOptionsFromParent(newValue) {
      this.items = newValue || []
    },

    // remote serach moethods
    onQueryChange(query) {
        if(this.trimDisabled){
          this.fetchRemoteResults(query)
        }
        else if (query.trim().length >= 2) {
          this.fetchRemoteResults(query)
        }
    },

    fetchRemoteResults: debounce(function (query) {
      this.select11Loading = true;
      let searchUrl = '';
      if(typeof this.url == 'function') {
          searchUrl = this.url(query)
          // console.log('selecturl', this.url, searchUrl)
      } else if(this.search == 'exact-search'){
          searchUrl = this.url + query
      }
       else {
          searchUrl = this.url + '*' + query + '*'
      }


      axios.get(searchUrl).then((resp) => {
        // console.log(resp)
        this.items = resp.data
        if(resp.data.length < 1) {
          this.select11NoResults = true;
        }
        return resp

      }).then((resp) => {
        this.select11Loading = false;
        this.select11LoadingTimeout = null;
      })

    }, 500)

  },
  watch: {
    value: function(newValue, oldValue) {

      this.updateValueFromParent(newValue)

    },
  },
  mounted() {

    //   this.loadCurrentValue()

  },
  created() {

    this.updateOptionsFromParent(this.options)
    this.updateValueFromParent(this.value)
    if(this.url && !this.remoteSearch) {
      // this.loadOptions()
    }


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.error {
  color: red;
}

.report-form {
  height: 50vh;
}

.actions {
  display: flex;
  align-content: center;
}
</style>
